import { Alert, Box, Button, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { useContext, useState } from "react";
import { UserContext } from "../../../contexts/user-context.jsx";
import { OrthomosaicDownload } from "./orthomosaic-download.jsx";
import { PointCloudDownload } from "./point-cloud-download.jsx";
import PaymentsIcon from "@mui/icons-material/Payments";
import { BuyProject } from "../buy/buy-project.jsx";
import { EditorPreview } from "../../editor/editor-preview.jsx";

export const ProjectResult = ({ project, onChanged }) => {
  const { t } = useTranslation(["project", "common"]);
  const { user } = useContext(UserContext);

  if (!project.orthomosaicUrl) return null;
  const [buyProject, setBuyProject] = useState(null);

  function onCloseBuyProject(success) {
    setBuyProject(null);
    if (success) {
      onChanged();
    }
  }

  let orthomosaic = <Box
    component="img"
    sx={{ width: "300px", height: "300px", objectFit: "contain", backgroundColor: "#ffffff" }}
    alt=""
    src={`${project.orthomosaicUrl}-300`}
    loading="lazy"
  />;

  if (!project.paid) {
    return <>
      <Alert severity="info" sx={{ mb: 3 }}>
        {t("unpaidResult")}
        <Button variant="outlined" startIcon={<PaymentsIcon/>}
                onClick={() => setBuyProject(project.id)} sx={{ mt: 2 }}>{t("buy")}</Button>
        <BuyProject open={buyProject !== null} onClose={onCloseBuyProject} projectId={buyProject}/>
      </Alert>
      <Typography variant="h6" sx={{ pb: 2 }}>{t("smallResPreview")}</Typography>
      <Box sx={{ display: "flex", gap: 2 }}>
        {orthomosaic}
        {!project.paid && <Box sx={{ width: 300, height: 300, overflow: "hidden" }}>
          <EditorPreview project={project}/>
        </Box>}
      </Box>
    </>
  }
  return (
    <>
      <RouterLink to={"editor"}>
        {orthomosaic}
      </RouterLink>
      <Box sx={{ mt: 1 }}></Box>
      <Button component={RouterLink} to={"editor"} variant="contained">
        {t("editor")}
      </Button>
      <Box sx={{ mt: 4 }}></Box>
      <TextField
        sx={{ maxWidth: "sm", width: "100%" }}
        label={t("publicLink")}
        variant="outlined"
        value={project.publicUrl}
      />
      {user && (user.role === "admin" || user.role === "developer") && (
        <Box sx={{ mt: 2 }}>
          <Button
            component={RouterLink}
            variant="outlined"
            to={project.reportUrl}
            target="_blank"
          >
            {t("processReport")}
          </Button>
        </Box>
      )}
      <Box sx={{ mt: 2 }}>
        <Typography variant="h6">{t("export")}</Typography>
        <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
          <OrthomosaicDownload project={project}/>
          <PointCloudDownload project={project}/>
        </Box>
      </Box>
    </>
  );
};
